import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {SessionStoreDataService} from '../../projects/products-lib/src/lib/services/session-store-data.service';

export const rootRedirectGuard: CanActivateFn = () => {
  const sessionStore = inject(SessionStoreDataService);
  const router = inject(Router);
  const decodedToken = sessionStore.getDecodedTokenUser();

  // Pupil members always go to 11+ dashboard
  if (sessionStore.isLoggedInSignal() && decodedToken?.isPupilMember) {
    return router.createUrlTree(['/11-plus-online-tests']);
  }

  // Users with full access see product selector (if they haven't already chosen)
  if (sessionStore.isLoggedInSignal() && sessionStore.hasFullAccess() && !sessionStorage.getItem('productSelected')) {
    return router.createUrlTree(['/product-selector']);
  }

  // Users with only digital products go to revision-hub
  if (sessionStore.isLoggedInSignal() && decodedToken?.hasActiveDigitalProducts && !decodedToken?.hasActiveSubscription) {
    return router.createUrlTree(['/revision-hub']);
  }

  // Users with only subscription go to 11+
  if (sessionStore.isLoggedInSignal() && decodedToken?.hasActiveSubscription && !decodedToken?.hasActiveDigitalProducts) {
    return router.createUrlTree(['/11-plus-online-tests']);
  }

  // Default: redirect to revision-hub
  return router.createUrlTree(['/revision-hub']);
};



